export default __webpack_public_path__ + "static/media/wisrSvg.5c3982fe.svg";